<template>
    <div>
        <notification-modal :vuexStore="vuexStore" :firstAction="firstAction" :firstActionText="firstActionText" :secondAction="secondAction" :secondActionText="secondActionText" :messageTitle="messageTitle" :message="message" :notificationType="notificationType" :resetVariable="resetVariable"></notification-modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            vuexStore: 'cancelRequest',
            messageTitle: 'Cancel request',
            message:  VueStore.state.cancelRequest.cancelConfirmMessage,
            notificationType: 'warning',
            firstAction: 'submitCancelRequestToServer',
            firstActionText: 'Yes, please cancel',
            secondAction: 'close',
            secondActionText: 'No, go back',
            resetVariable: 'showCancelRequestConfirm'
        }
    },
}
</script>